import { render } from "./SubMenu.vue?vue&type=template&id=291aa980&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=291aa980&scoped=true&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291aa980"]])

export default __exports__